<template>
  <div class="delete-undo-toast">
    <span class="delete-undo-message">{{ message }}</span>
    <button type="button" cy="delete-undo-btn" class="delete-undo-btn" @click="handleUndo">
      {{ undoLabel }}
    </button>
  </div>
</template>

<script>
  export default {
    name: "DeleteUndoToast",
    props: {
      message: {
        type: String,
        required: true
      },
      undoLabel: {
        type: String,
        required: true
      }
    },
    methods: {
      handleUndo () {
        this.$emit('undo');
        this.$emit('close-toast');
      }
    }
  }
</script>

<style lang="less">
  .delete-undo-toast {
    @media only screen and (min-width: 0) {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      width: 100%;

      .delete-undo-message {
        color: white;
        font-size: 1.5rem;
        font-weight: 500;
      }

      .delete-undo-btn {
        flex: 0 0 auto;
        padding: 6px 14px;
        border-radius: 999px;
        background-color: rgba(255, 255, 255, 0.16);
        color: white;
        font-size: 1.4rem;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.02em;
        transition: background-color ease-in-out 0.12s;

        &:hover {
          background-color: rgba(255, 255, 255, 0.28);
        }

        &:active {
          background-color: rgba(255, 255, 255, 0.36);
        }
      }
    }
  }
</style>
